import { Grid, Paper, Typography, Button } from '@material-ui/core';
import Box from '@mui/material/Box';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAddMoney } from '../../../../shared/context';
import { AppState } from '../../../../store/rootReducer';
import { useHistory } from 'react-router-dom';

const investmentBox = {
    height: '60vh',
    background: '#ff0028',
    borderRadius: "0% 0% 49% 51% / 0% 0% 32% 17% "
}

const investHeading = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: "#fff",
    padding: '20px',
}

const bankAccountItem = {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px auto',
    width: '60%',
    borderRadius: '10px',
    padding: '10px 0',
    background: '#000066',
    color: "#fff"
}

const PaymentMode = () => {
    let history = useHistory();
    const {state} = useAddMoney();

    const ViewBankDetails = () => {
        history.push({
            pathname:'/p2p/bank-detail'
        })
    }

    const backRoute = () => {
        history.goBack()
    }

    const { dashboardSummary } = useSelector((state: AppState) => state.dashboard);

    return (
        <>
            <Grid>
                    <Box style={investmentBox}>
                        <Box style={investHeading} >
                            <Button style={{cursor:'pointer',color:"#fff"}} onClick= {()=>backRoute()}> <ArrowBackIosIcon fontSize="small"/> </Button>
                            <Typography > add money to stashearn</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: "#fff", margin: '30px auto' }}>
                            <Typography>current balance</Typography>
                            <Button style={{ width: '30%', background: '#fff', color: "#000066", fontWeight: 'bold' }}>{dashboardSummary?.account_balance || 0}</Button>
                            <Typography>investing</Typography>
                            <Button style={{ width: '30%', background: '#fff', color: "#000066", fontWeight: 'bold' }}>{state.amount || 0}</Button>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '20px auto',
                    }}>
                        <Box>
                            <Typography align='center'> add using bank account</Typography>
                        </Box>
                        <Box >
                            <Button style={bankAccountItem} onClick={ViewBankDetails}>view</Button>
                        </Box>
                    </Box>
            </Grid>
        </>
    )
}

export default PaymentMode;